/**
 * upload模块接口列表
 */

import axios from "@/api/http"; // 导入http中创建的axios实例
import base from "@/api//base"; // 导入接口域名列表
const upload = {
  // POST/file/loadFile 媒体数据上传
  loadFile(file) {
    return axios.post(`${base.baseURL_clinic}file/loadFile`, file);
  }
};
export default upload;



// WEBPACK FOOTER //
// ./src/network/upload.js